/* =============================================================================
   christina-ux-r9.js — v1.2 (2026-08-05)
   Runda BUGS-B. Poprawki warstwy prezentacji i dostępności, wszystkie nałożone
   Z ZEWNĄTRZ na motyw bazowy (assets/theme.js, 267 KB, zminifikowany).
   Plik ładowany z `snippets/js-variables.liquid` z atrybutem `defer`, czyli
   ZAWSZE po theme.js — w chwili startu `customElements` ma już definicje.

   Dlaczego z zewnątrz, a nie w theme.js: theme.js to zminifikowany plik motywu
   Concept 5.3.1. Każda ingerencja w niego znika przy aktualizacji motywu i nie
   da się jej zrecenzować w diffie. Ten sam wzorzec ma już
   `christina-cart-runtime.js` (null-safe theme.a11y.trapFocus).

   v1.1 — grupowanie koszyka przepięte z przebiegów czasowych na obserwator.
   v1.2 — poprawiona liczba mnoga licznika dla zh-TW (patrz punkt 2).

   ── 1. BUG-02 / BUG-08 — fokus po otwarciu szuflady koszyka i quick view ─────
   Przyczyna, jedna dla obu: `ModalElement` w theme.js ma getter

       get focusElement(){ return this.querySelector("gesture-element")
                                || this.querySelector("button") }

   a `afterShow()` woła `theme.a11y.trapFocus(this, this.focusElement)`.
   Każda szuflada motywu zawiera `<gesture-element class="drawer__header"
   tabindex="0">` — obsługę gestu przeciągnięcia na dotyku. Jest to pierwszy
   `gesture-element` w drzewie, więc alternatywa `|| button` NIGDY się nie
   wykonuje. Fokus ląduje na opakowaniu, które nie jest kontrolką, nie ma
   nazwy dostępnej ani stylu fokusu (zmierzone: `document.activeElement` =
   GESTURE-ELEMENT.drawer__header, `outline-style: none`).

   Poprawka: podmieniamy getter na PROTOTYPIE, który go definiuje, na
   „pierwsza widoczna kontrolka wewnątrz modala”. Prototyp wyszukujemy po
   TREŚCI gettera — musi zawierać literał `gesture-element`. To gwarantuje, że
   nie podmienimy `SearchDrawer.focusElement` (zwraca input wyszukiwania —
   zachowanie poprawne) ani wariantu z `summary.nextElementSibling`.

   Pułapka fokusa i powrót na wyzwalacz DZIAŁAŁY już przed poprawką i nie są
   ruszane: `afterShow` zakłada trap na `this` (czyli tylko na otwartym
   modalu), a `afterHide` woła `removeTrapFocus(this.activeElement)`. Zmierzone
   przed zmianą: Escape w quick view → fokus wraca na przycisk „Pogląd”.

   Dodatkowo zdejmujemy `gesture-element` z kolejności TAB wewnątrz szuflad
   (`tabindex="0"` → `"-1"`). Element nie ma roli ani nazwy, a obsługa gestu
   jest dotykowa — dla klawiatury był to martwy przystanek.

   ── 2. BUG-05 — aria-label licznika koszyka ─────────────────────────────────
   `CartCount.onCartUpdate` w theme.js robi wyłącznie:
       this.innerText = event.cart.item_count; this.hidden = ...
   `aria-label` jest renderowany w Liquid i nigdy nie jest odświeżany.
   Zmierzone: po „Dodaj do koszyka” tekst = „6”, `aria-label` = „5 elementów”.

   Poprawka: opakowujemy `onCartUpdate` tak, by etykieta powstawała z TEJ SAMEJ
   odpowiedzi `cart.js`, w tym samym zadaniu co tekst. Obserwator mutacji jest
   siatką bezpieczeństwa dla drugiego pisarza — `christina-cart-runtime.js`
   wyrównuje licznik po nawigacji wstecz, pisząc bezpośrednio `innerText`.

   TREŚĆ ETYKIETY NIE JEST WYMYŚLANA. Podstawowym źródłem jest etykieta
   wyrenderowana przez serwer: zdejmujemy z niej wzorzec (podmieniamy liczbę na
   `{n}`) i używamy go dalej. Tabela `LICZNIK` służy WYŁĄCZNIE do sytuacji,
   w której liczba przeszła do innej klasy liczby mnogiej niż ta, dla której
   zdjęliśmy wzorzec — i zawiera tylko języki, których obie formy zmierzono na
   produkcji 05.08.2026:
       pl  1 → „1 elementu”   2 → „2 elementów”   (locales/pl.json ma one/other)
       en  1 → „1 item”       2 → „2 items”

   zh-TW CELOWO NIE MA WPISU w tabeli. Zmierzone: `/zh/` zwraca „1 件商品”
   i „2 件商品”, czyli forma jest niezmienna — chińszczyzna nie odmienia
   liczebnika. Wpis w tabeli (v1.0–v1.1 dziedziczył formy polskie) sprawiłby,
   że przy przejściu 2 → 1 klient zh-TW dostałby „1 elementu”. Brak wpisu
   oznacza „zawsze używaj wzorca z serwera”, co dla zh-TW jest poprawne i dla
   każdego przyszłego języka bez zmierzonych form jest bezpieczne.

   Polskie formy są gramatycznie niepoprawne („1 elementu”, „2 elementów”), ale
   to treść z `locales/*`, których ten plik NIE poprawia — celem jest zgodność
   etykiety z liczbą, nie zmiana copy.

   ── 3. BUG-10 — komunikat o wynikach podpowiedzi wyszukiwania ───────────────
   `PredictiveSearch.renderSearchResults` (assets/search.js) podmienia
   `innerHTML` kontenera `#PredictiveSearchResults-*`. Kontener ma
   `role="listbox"`, ale nie ma `aria-live` — zmierzone: jedyne regiony live na
   stronie to pusty `slideshow-control` i `.cca-msgs` czatu AI.

   Poprawka: dokładamy JEDEN dedykowany region `role="status" aria-live="polite"`
   na formularz. Kontener wyników zostaje `role="listbox"` bez zmian — nie
   robimy z niego regionu live, bo wtedy czytnik odczytywałby całą listę
   produktów przy każdym naciśnięciu klawisza.

   ── 4. BUG-10 (druga część) — pierwszy klik po zimnym starcie ───────────────
   Zmierzone na produkcji (PDP, sieć bez dławienia): FCP 976 ms, a wykonanie
   odroczonych skryptów motywu — czyli podniesienie `<search-drawer>` i
   podpięcie `[aria-controls]` w `ModalElement.connectedCallback` — dopiero
   przy `domInteractive` 1188 ms. Przez ~210 ms (na telefonie w 4G dłużej)
   ikona wyszukiwania JEST NARYSOWANA i klikalna, ale nie ma jeszcze żadnego
   nasłuchu. Klik przepada bez śladu.

   Poprawka jest DWUCZĘŚCIOWA; drugą część ma `snippets/js-variables.liquid`:
   tam, w skrypcie inline w <head> (wykonywanym w trakcie parsowania, czyli
   PRZED tym plikiem), stoi listener w fazie przechwytywania, który zapisuje
   klik w `window.__ccEarlyClicks` — ale TYLKO jeśli element docelowy nie jest
   jeszcze podniesiony. Tutaj taki klik odtwarzamy. Kiedy motyw zdążył, kolejka
   jest pusta (zero ryzyka podwójnego otwarcia).

   ── 5. BUG-03 — dwa wiersze tej samej pozycji w koszyku ─────────────────────
   To NIE jest defekt: przy rabacie pakietowym Shopify alokuje rabat na część
   sztuk, a linia z inną alokacją musi mieć własny klucz. Zmierzone /cart.js:
   ten sam `variant_id`, dwa różne `key`, 2 szt. bez rabatu i 1 szt.
   z `line_level_total_discount` — suma zgadza się co do grosza.

   Robimy WYŁĄCZNIE poprawę prezentacji: sąsiadujące wiersze tego samego
   wariantu dostają wspólną kreskę po lewej i podpis nad grupą. Zero zmian
   w kluczach linii, zero zmian w aktualizacji ilości (motyw dalej wysyła
   `updates[]` po `data-index`, czyli po kluczu linii).

   Rollback całości: usuń dwie linie z `snippets/js-variables.liquid`
   (<link> i <script>) oraz blok inline oznaczony `BUGS-B`.
   ============================================================================= */
(function () {
  'use strict';

  if (window.__ccUxR9) { return; }
  window.__ccUxR9 = '1.2';

  /* ------------------------------------------------------------------ i18n */

  function jezyk() {
    var l = (window.Shopify && window.Shopify.locale) ||
            document.documentElement.getAttribute('lang') || 'pl';
    l = String(l);
    if (l.indexOf('en') === 0) { return 'en'; }
    if (l.indexOf('zh') === 0) { return 'zh-TW'; }
    return 'pl';
  }
  var JEZYK = jezyk();

  /* Formy licznika koszyka — TYLKO języki z obiema formami zmierzonymi na
     produkcji. Brak wpisu = „zawsze wzorzec z serwera” (patrz nagłówek). */
  var LICZNIK = {
    'pl': { one: '{n} elementu', other: '{n} elementów' },
    'en': { one: '{n} item',     other: '{n} items' }
  };

  /* Teksty własne tego pliku — tu polska liczba mnoga jest już poprawna. */
  var TEKSTY = {
    'pl': {
      szukanie: 'Wyszukiwanie…',
      brakWynikow: 'Brak wyników',
      wynik1: '1 wynik',
      wynikiFew: '{n} wyniki',
      wynikiMany: '{n} wyników',
      grupa: 'Ta sama pozycja w {n} wierszach — rabat pakietowy obejmuje część sztuk.'
    },
    'en': {
      szukanie: 'Searching…',
      brakWynikow: 'No results',
      wynik1: '1 result',
      wynikiFew: '{n} results',
      wynikiMany: '{n} results',
      grupa: 'Same item split into {n} lines — the bundle discount covers part of the quantity.'
    },
    'zh-TW': {
      szukanie: '搜尋中…',
      brakWynikow: '沒有結果',
      wynik1: '1 個結果',
      wynikiFew: '{n} 個結果',
      wynikiMany: '{n} 個結果',
      grupa: '同一項商品分成 {n} 行 — 套裝折扣僅適用部分數量。'
    }
  };
  var T = TEKSTY[JEZYK] || TEKSTY.pl;

  function liczbaWynikow(n) {
    if (n === 0) { return T.brakWynikow; }
    if (n === 1) { return T.wynik1; }
    if (JEZYK === 'pl') {
      var d = n % 10, s = n % 100;
      var few = d >= 2 && d <= 4 && !(s >= 12 && s <= 14);
      return (few ? T.wynikiFew : T.wynikiMany).replace('{n}', n);
    }
    return T.wynikiFew.replace('{n}', n);
  }

  /* --------------------------------------------------------------- narzędzia */

  function idle(fn, timeout) {
    var r = window.requestIdleCallback;
    if (r) { try { r(fn, { timeout: timeout || 500 }); return; } catch (e) { /* pomijamy */ } }
    setTimeout(fn, 32);
  }

  function widoczny(el) {
    if (!el || !el.getClientRects) { return false; }
    if (!el.getClientRects().length) { return false; }
    var cs;
    try { cs = window.getComputedStyle(el); } catch (e) { return false; }
    return cs.visibility !== 'hidden' && cs.display !== 'none';
  }

  /* ================================================================= 1. FOKUS
     BUG-02 (szuflada koszyka) + BUG-08 (quick view) — wspólna przyczyna. */

  var FOKUSOWALNE = [
    'button:not([disabled])',
    'a[href]',
    'input:not([type="hidden"]):not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex^="-"])'
  ].join(',');

  function pierwszaKontrolka(modal) {
    var kandydaci;
    try { kandydaci = modal.querySelectorAll(FOKUSOWALNE); } catch (e) { return null; }
    for (var i = 0; i < kandydaci.length; i++) {
      var el = kandydaci[i];
      /* Samo opakowanie gestu odrzucamy — ale JEGO DZIECI (przycisk zamknięcia
         siedzi właśnie w środku) są jak najbardziej dobrymi kandydatami. */
      if (el.tagName === 'GESTURE-ELEMENT') { continue; }
      if (el.hasAttribute('inert') || el.closest('[inert]')) { continue; }
      if (el.closest('[aria-hidden="true"]')) { continue; }
      if (!widoczny(el)) { continue; }
      return el;
    }
    return null;
  }

  /* Znak dla CSS: element, na który sami przenieśliśmy fokus przy otwarciu
     dialogu — ma dostać widoczny pierścień 2 px / offset 3 px także wtedy, gdy
     przeglądarka nie uzna tego za `:focus-visible` (fokus nadany skryptem po
     kliknięciu myszą). Znak zdejmujemy przy `blur`, żeby obramowanie nie
     zostało na stałe. */
  function oznaczFokus(el) {
    if (!el || !el.setAttribute) { return; }
    el.setAttribute('data-cc-dialogfocus', '');
    var zdejmij = function () {
      el.removeAttribute('data-cc-dialogfocus');
      el.removeEventListener('blur', zdejmij);
    };
    el.addEventListener('blur', zdejmij);
  }

  /* Szukamy PROTOTYPU, który definiuje wadliwy getter. Rozpoznajemy go po
     literale `gesture-element` w treści funkcji — dzięki temu nie tkniemy
     `SearchDrawer.focusElement` (input) ani wariantu z `summary`. */
  function prototypZWadliwymGetterem() {
    var nazwy = ['cart-drawer', 'quick-view', 'x-modal', 'menu-drawer'];
    for (var i = 0; i < nazwy.length; i++) {
      var C = window.customElements && customElements.get(nazwy[i]);
      if (!C) { continue; }
      var p = C.prototype;
      while (p && p !== HTMLElement.prototype && p !== Object.prototype) {
        var d = Object.getOwnPropertyDescriptor(p, 'focusElement');
        if (d && typeof d.get === 'function') {
          if (String(d.get).indexOf('gesture-element') > -1) { return p; }
          break;   /* własny, poprawny getter tej klasy — nie schodzimy wyżej */
        }
        p = Object.getPrototypeOf(p);
      }
    }
    return null;
  }

  function naprawFokusModali() {
    var proto = prototypZWadliwymGetterem();
    if (!proto) { return false; }
    if (proto.__ccFokusR9) { return true; }
    proto.__ccFokusR9 = 1;
    Object.defineProperty(proto, 'focusElement', {
      configurable: true,
      get: function () {
        var el = pierwszaKontrolka(this);
        if (el) { oznaczFokus(el); return el; }
        /* Awaryjnie zachowanie motywu — lepsze to niż wyjątek. */
        return this.querySelector('button') || this.querySelector('gesture-element') || this;
      }
    });
    return true;
  }

  /* `gesture-element` poza kolejnością TAB — wewnątrz szuflad i modali. */
  function odtabujGesty(korzen) {
    var sel = '[role="dialog"] gesture-element[tabindex="0"], .drawer gesture-element[tabindex="0"]';
    var lista;
    try { lista = (korzen || document).querySelectorAll(sel); } catch (e) { return; }
    for (var i = 0; i < lista.length; i++) { lista[i].setAttribute('tabindex', '-1'); }
  }

  /* ============================================================ 2. BUG-05 ===
     aria-label licznika koszyka aktualizowany razem z liczbą. */

  var wzorSerwera = null;   /* np. „{n} elementów” — zdjęty z renderu serwera */
  var klasaSerwera = null;  /* 'one' | 'other' — dla jakiej liczby go zdjęto  */

  function klasaMnogosci(n) { return n === 1 ? 'one' : 'other'; }

  function etykietaLicznika(n) {
    var tbl = LICZNIK[JEZYK] || null;
    var taSamaKlasa = (klasaSerwera === klasaMnogosci(n));
    /* Wzorzec z serwera jest zawsze pierwszym wyborem. Ustępuje tylko wtedy,
       gdy liczba zmieniła klasę mnogości I mamy dla tego języka zmierzone
       obie formy. Dla zh-TW (brak wpisu) oznacza to wzorzec zawsze — i o to
       chodzi, bo forma jest tam niezmienna. */
    if (wzorSerwera && (taSamaKlasa || !tbl)) { return wzorSerwera.replace('{n}', n); }
    if (tbl) { return (n === 1 ? tbl.one : tbl.other).replace('{n}', n); }
    return String(n);
  }

  function zapamietajWzor(el) {
    if (wzorSerwera) { return; }
    var a = el.getAttribute('aria-label');
    var n = parseInt(el.textContent, 10);
    if (!a || !/\d/.test(a) || isNaN(n)) { return; }
    wzorSerwera = a.replace(/\d+/, '{n}');
    klasaSerwera = klasaMnogosci(n);
  }

  function ustawEtykiete(el, n) {
    /* T-UR603-2 (2026-10-12): Concept 6.0.3 renderuje wlasna etykiete w <span class="sr-only"> i sam ja
       aktualizuje (theme.js CartCount + christina-cart-runtime). Nasz aria-label dublowal ja z twarda tabela
       odmian — gdy jest natywna etykieta, zdejmujemy aria-label i nic nie robimy. */
    if (el && el.querySelector && el.querySelector('.sr-only')) { if (el.hasAttribute('aria-label')) { el.removeAttribute('aria-label'); } return; }
    if (!el || typeof n !== 'number' || isNaN(n)) { return; }
    var nowa = etykietaLicznika(n);
    if (el.getAttribute('aria-label') !== nowa) { el.setAttribute('aria-label', nowa); }
  }

  function podepnijLiczniki() {
    var lista = document.querySelectorAll('cart-count');
    for (var i = 0; i < lista.length; i++) {
      var el = lista[i];
      zapamietajWzor(el);
      if (el.__ccLicznikR9) { continue; }
      el.__ccLicznikR9 = 1;
      /* Wyrównanie stanu zastanego (np. po powrocie z bfcache, gdzie
         christina-cart-runtime.js pisze sam innerText). */
      ustawEtykiete(el, parseInt(el.textContent, 10));
      try {
        new MutationObserver(function (recs) {
          var t = recs[0] && recs[0].target;
          var host = t && (t.nodeType === 1 ? t : t.parentElement);
          if (!host) { return; }
          if (host.tagName !== 'CART-COUNT') { host = host.closest && host.closest('cart-count'); }
          if (host) { ustawEtykiete(host, parseInt(host.textContent, 10)); }
        }).observe(el, { childList: true, characterData: true, subtree: true });
      } catch (e) { /* pomijamy */ }
    }
  }

  /* Ścieżka główna: ta sama odpowiedź cart.js, to samo zadanie co `innerText`. */
  function naprawLicznik() {
    var CC = window.customElements && customElements.get('cart-count');
    if (!CC) { return false; }
    if (CC.prototype.__ccLicznikPatchR9) { return true; }
    if (typeof CC.prototype.onCartUpdate !== 'function') { return false; }
    CC.prototype.__ccLicznikPatchR9 = 1;
    var orig = CC.prototype.onCartUpdate;
    CC.prototype.onCartUpdate = function (event) {
      var wynik = orig.apply(this, arguments);
      try {
        if (event && event.cart && !event.cart.errors) {
          ustawEtykiete(this, event.cart.item_count);
        }
      } catch (e) { /* pomijamy */ }
      return wynik;
    };
    return true;
  }

  /* ============================================================ 3. BUG-10 ===
     Region live dla podpowiedzi wyszukiwania. */

  function kontenerWynikow(form) {
    return form.querySelector('[id^="PredictiveSearchResults"]') ||
           document.querySelector('[id^="PredictiveSearchResults"]');
  }

  function statusDla(form) {
    /* T-UR603-3 (2026-10-12): 6.0.3 ma natywny region <p class="search__status" role="status">,
       ktory search.js wypelnia po kazdym renderze. Drugi region dublowal komunikaty — przy natywnym nie tworzymy wlasnego. */
    if (form.querySelector('.search__status')) { var stary = form.querySelector('[data-cc-ps-status]'); if (stary) { stary.remove(); } return null; }
    var s = form.querySelector('[data-cc-ps-status]');
    if (s) { return s; }
    s = document.createElement('p');
    s.className = 'cc-sr-only';
    s.setAttribute('data-cc-ps-status', '');
    s.setAttribute('role', 'status');
    s.setAttribute('aria-live', 'polite');
    s.setAttribute('aria-atomic', 'true');
    form.appendChild(s);
    return s;
  }

  function napiszStatus(form) {
    var s = statusDla(form);
    if (!s) { return; }
    var input = form.querySelector('input[type="search"]');
    var fraza = input ? input.value.trim() : '';
    if (!fraza) { if (s.textContent !== '') { s.textContent = ''; } return; }
    if (form.hasAttribute('loading')) {
      if (s.textContent !== T.szukanie) { s.textContent = T.szukanie; }
      return;
    }
    if (!form.hasAttribute('results')) { return; }
    var kont = kontenerWynikow(form);
    var n = kont ? kont.querySelectorAll('li').length : 0;
    var tekst = liczbaWynikow(n);
    if (s.textContent !== tekst) { s.textContent = tekst; }
  }

  function podepnijWyszukiwarki() {
    var formy = document.querySelectorAll('form[is="predictive-search"]');
    for (var i = 0; i < formy.length; i++) {
      var f = formy[i];
      if (f.__ccPsR9) { continue; }
      if (f.querySelector('.search__status')) { f.__ccPsR9 = 1; continue; }
      f.__ccPsR9 = 1;
      statusDla(f);
      (function (form) {
        try {
          /* Atrybuty `loading` / `results` ustawia sam PredictiveSearch. */
          new MutationObserver(function () { napiszStatus(form); })
            .observe(form, { attributes: true, attributeFilter: ['loading', 'results'] });
          var kont = kontenerWynikow(form);
          if (kont) {
            new MutationObserver(function () { napiszStatus(form); })
              .observe(kont, { childList: true, subtree: false });
          }
        } catch (e) { /* pomijamy */ }
      })(f);
    }
  }

  /* ============================================================ 4. BUG-10b ==
     Odtworzenie kliku, który padł przed podniesieniem elementów motywu. */

  function odtworzWczesneKliki() {
    var kolejka = window.__ccEarlyClicks;
    if (!kolejka || !kolejka.length) { return; }
    window.__ccEarlyClicks = [];
    var wpis = kolejka[kolejka.length - 1];   /* tylko ostatni — bez kaskady */
    if (!wpis || !wpis.id) { return; }
    var el = document.getElementById(wpis.id);
    if (!el || el.hasAttribute('open')) { return; }
    var C = window.customElements && customElements.get(el.tagName.toLowerCase());
    if (!C || !(el instanceof C) || typeof el.show !== 'function') { return; }
    try { el.show(wpis.trigger || null); } catch (e) { /* pomijamy */ }
  }

  /* ============================================================ 5. BUG-03 ===
     Wizualne zgrupowanie sąsiednich wierszy tego samego wariantu.
     ŻADNEJ zmiany logiki: klucze linii i `updates[]` zostają nietknięte.

     v1.1 — dlaczego obserwator, a nie przebiegi czasowe:
     zawartość `<cart-drawer>` jest dociągana leniwie (`data-cclazy-part="cart"`)
     i podmieniana przez cart.js po każdej zmianie ilości. Przebiegi na
     DOMContentLoaded + 1,2 s + 4 s wypadały ZANIM lista w ogóle istniała —
     zmierzone: dwa wiersze tego samego wariantu w DOM, zero klas `.cc-dup`.

     Pętli sprzężenia zwrotnego nie ma, bo funkcja jest IDEMPOTENTNA: liczy
     podpis stanu (ciąg identyfikatorów wariantów wierszy) i przy zgodnym
     podpisie NIE DOTYKA DOM w ogóle. Wstawiony przez nas `li.cc-dup__note`
     nie ma `data-variant-id`, więc nie wchodzi do podpisu — drugi przebieg po
     naszej własnej mutacji kończy się bez zapisu i obserwator milknie. */

  var mutujeKoszyk = false;

  function grupujKoszyk() {
    var listy = document.querySelectorAll('ul.horizontal-products');
    for (var i = 0; i < listy.length; i++) {
      var lista = listy[i];

      var wiersze = [];
      var dzieci = lista.children;
      for (var d = 0; d < dzieci.length; d++) {
        if (dzieci[d].hasAttribute && dzieci[d].hasAttribute('data-variant-id')) {
          wiersze.push(dzieci[d]);
        }
      }

      var podpis = '';
      for (var p = 0; p < wiersze.length; p++) {
        podpis += wiersze[p].getAttribute('data-variant-id') + '|';
      }
      if (lista.__ccGrpPodpis === podpis) { continue; }   /* nic się nie zmieniło */

      mutujeKoszyk = true;

      var stare = lista.querySelectorAll('.cc-dup__note');
      for (var s = 0; s < stare.length; s++) { stare[s].remove(); }
      for (var o = 0; o < wiersze.length; o++) {
        wiersze[o].classList.remove('cc-dup', 'cc-dup--first', 'cc-dup--last');
      }

      var start = 0;
      while (start < wiersze.length) {
        var vid = wiersze[start].getAttribute('data-variant-id');
        var koniec = start;
        while (koniec + 1 < wiersze.length &&
               wiersze[koniec + 1].getAttribute('data-variant-id') === vid) {
          koniec++;
        }
        var ile = koniec - start + 1;
        if (ile > 1) {
          for (var k = start; k <= koniec; k++) { wiersze[k].classList.add('cc-dup'); }
          wiersze[start].classList.add('cc-dup--first');
          wiersze[koniec].classList.add('cc-dup--last');
          var notka = document.createElement('li');
          notka.className = 'cc-dup__note';
          notka.textContent = T.grupa.replace('{n}', ile);
          lista.insertBefore(notka, wiersze[start]);
        }
        start = koniec + 1;
      }

      lista.__ccGrpPodpis = podpis;
      mutujeKoszyk = false;
    }
  }

  /* Obserwator na kontenerach koszyka. Zakres celowo wąski — `<cart-drawer>`
     i `<cart-items>`, nigdy `document.body`. */
  function podepnijObserwatorKoszyka() {
    var korzenie = document.querySelectorAll('cart-drawer, cart-items');
    for (var i = 0; i < korzenie.length; i++) {
      var r = korzenie[i];
      if (r.__ccGrpObs) { continue; }
      r.__ccGrpObs = 1;
      try {
        new MutationObserver(function () {
          if (mutujeKoszyk) { return; }
          zaplanujGrupowanie();
        }).observe(r, { childList: true, subtree: true });
      } catch (e) { /* pomijamy */ }
    }
  }

  var grupowanieCzeka = false;
  function zaplanujGrupowanie() {
    if (grupowanieCzeka) { return; }
    grupowanieCzeka = true;
    idle(function () { grupowanieCzeka = false; grupujKoszyk(); }, 400);
  }

  /* ------------------------------------------------------------------ start */

  var gotowe = false;

  function startuj() {
    if (!gotowe) {
      gotowe = naprawFokusModali() && naprawLicznik();
    }
    odtabujGesty(document);
    podepnijLiczniki();
    podepnijWyszukiwarki();
    podepnijObserwatorKoszyka();
    grupujKoszyk();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      startuj();
      odtworzWczesneKliki();
    }, { once: true });
  } else {
    startuj();
    odtworzWczesneKliki();
  }

  /* Kolejny przebieg po zdarzeniach, które podmieniają fragmenty DOM.
     Wszystko idzie przez `requestIdleCallback`, żeby nie przedłużać cudzych
     zadań — ta sama zasada, którą wymusiła runda R6-W6. */
  var zaplanowany = false;
  function zaplanuj() {
    if (zaplanowany) { return; }
    zaplanowany = true;
    idle(function () { zaplanowany = false; startuj(); }, 500);
  }

  ['cart:updated', 'cart:refresh', 'modal:afterShow', 'quickview:loaded', 'shopify:section:load']
    .forEach(function (n) { document.addEventListener(n, zaplanuj, true); });
  window.addEventListener('pageshow', zaplanuj);

  /* Dwa kontrolne przebiegi: definicje custom elements mogą dojechać później,
     gdyby kiedyś zmieniła się kolejność skryptów. */
  setTimeout(startuj, 1200);
  setTimeout(startuj, 4000);
})();
